import AuthProvider from "../components/AuthProvider";
import DashboardLayout from "../components/DashboardLayout";
import { getReportPageName } from "../helper/GlobalValueHelper";
import List from "../views/report/List";

const ReportRoute = {
  path: "/",
  element: <DashboardLayout />,
  children: [
    {
      path: "/report",
      element: (
        <AuthProvider page={getReportPageName()} action={"view"}>
          <List />
        </AuthProvider>
      ),
    },
  ],
};

export default ReportRoute;
